import { getConfig } from '@townsquare/config';

import AvailableSitesProvider from './AvailableSites';

export const resolvedAvailableSitesProvider: AvailableSitesProvider = new AvailableSitesProvider(getConfig().availableProductsUrl);
